// extracted by mini-css-extract-plugin
export default {"imageWrapper":"gL-z","twoColumnImage":"hL-z"};